import _classCallCheck from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/createClass.js";
import { Crc32 } from "@aws-crypto/crc32";
import { HeaderMarshaller } from "./HeaderMarshaller";
import { splitMessage } from "./splitMessage";
export var EventStreamCodec = /*#__PURE__*/function () {
  function EventStreamCodec(toUtf8, fromUtf8) {
    _classCallCheck(this, EventStreamCodec);
    this.headerMarshaller = new HeaderMarshaller(toUtf8, fromUtf8);
    this.messageBuffer = [];
    this.isEndOfStream = false;
  }
  _createClass(EventStreamCodec, [{
    key: "feed",
    value: function feed(message) {
      this.messageBuffer.push(this.decode(message));
    }
  }, {
    key: "endOfStream",
    value: function endOfStream() {
      this.isEndOfStream = true;
    }
  }, {
    key: "getMessage",
    value: function getMessage() {
      var message = this.messageBuffer.pop();
      var _isEndOfStream = this.isEndOfStream;
      return {
        getMessage: function getMessage() {
          return message;
        },
        isEndOfStream: function isEndOfStream() {
          return _isEndOfStream;
        }
      };
    }
  }, {
    key: "getAvailableMessages",
    value: function getAvailableMessages() {
      var messages = this.messageBuffer;
      this.messageBuffer = [];
      var _isEndOfStream2 = this.isEndOfStream;
      return {
        getMessages: function getMessages() {
          return messages;
        },
        isEndOfStream: function isEndOfStream() {
          return _isEndOfStream2;
        }
      };
    }
  }, {
    key: "encode",
    value: function encode(_ref) {
      var rawHeaders = _ref.headers,
        body = _ref.body;
      var headers = this.headerMarshaller.format(rawHeaders);
      var length = headers.byteLength + body.byteLength + 16;
      var out = new Uint8Array(length);
      var view = new DataView(out.buffer, out.byteOffset, out.byteLength);
      var checksum = new Crc32();
      view.setUint32(0, length, false);
      view.setUint32(4, headers.byteLength, false);
      view.setUint32(8, checksum.update(out.subarray(0, 8)).digest(), false);
      out.set(headers, 12);
      out.set(body, headers.byteLength + 12);
      view.setUint32(length - 4, checksum.update(out.subarray(8, length - 4)).digest(), false);
      return out;
    }
  }, {
    key: "decode",
    value: function decode(message) {
      var _splitMessage = splitMessage(message),
        headers = _splitMessage.headers,
        body = _splitMessage.body;
      return {
        headers: this.headerMarshaller.parse(headers),
        body: body
      };
    }
  }, {
    key: "formatHeaders",
    value: function formatHeaders(rawHeaders) {
      return this.headerMarshaller.format(rawHeaders);
    }
  }]);
  return EventStreamCodec;
}();